/**
 * Simple store class for projectListItem objects
 */
export default class ProjectListItemStore {
    projectListItems = new Map();

    /**
     * Fully overwrite the current store with the items in the given object map
     *
     * @param {Object} projectListItems Project list items
     */
    setProjectListItems(projectListItems = {}) {
        this.projectListItems.clear();

        Object
            .keys(projectListItems)
            .forEach(id => this.projectListItems.set(Number(id), projectListItems[id]));
    }

    /**
     * Is this project list item available?
     *
     * @param {number} id
     *
     * @return {boolean}
     */
    hasProjectListItem(id) {
        return this.projectListItems.has(id);
    }

    /**
     * Return project list item
     *
     * @param {number} id
     *
     * @return {ProductFamily}
     */
    getProjectListItem(id) {
        return this.projectListItems.get(id);
    }
}
